import { useCallback } from 'react';

import { useDispatch, useSelector } from 'app/store';
import CountryTile from 'modules/editor/components/Settings/CountryTile';
import {
  settingsCountrySelector,
  settingsCountryUpdate,
  settingsUserCountrySelector,
  settingsUserLocationSelectable,
} from 'modules/settings/slice';
import { trackEvent } from 'utils/googleAnalytics';

const CountryTileContainer = () => {
  const country = useSelector(settingsCountrySelector);
  const userCountry = useSelector(settingsUserCountrySelector);
  const userLocationSelectable = useSelector(settingsUserLocationSelectable);

  const dispatch = useDispatch();

  const onCountryChange = useCallback(
    (newCountry: string) => {
      dispatch(settingsCountryUpdate({ country: newCountry }));
      trackEvent('settingsChange', { setting: 'country', newValue: newCountry });
    },
    [dispatch]
  );
  const onUseUserLocation = useCallback(() => {
    if (userCountry) {
      dispatch(settingsCountryUpdate({ country: userCountry }));
    }
    trackEvent('settingsChange', { setting: 'useUserLocation', newValue: 'true' });
  }, [dispatch, userCountry]);

  const isUserLocation = country === userCountry;

  return (
    <CountryTile
      country={country}
      isUserLocation={isUserLocation}
      onCountryChange={onCountryChange}
      onUseUserLocation={onUseUserLocation}
      userLocationSelectable={userLocationSelectable}
    />
  );
};

export default CountryTileContainer;
